


import React from 'react';
import { Box, Container, Typography, Card, CardContent, Grid, Paper, useTheme, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';


const StatsCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3),
    height: '100%',
    background: 'white',
    boxShadow: '0 8px 32px rgba(0, 106, 98, 0.1)',
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
        transform: 'translateY(-5px)',
    },
}));

const IconBox = styled(Box)(({ theme }) => ({
    width: 60,
    height: 60,
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
    background: '#006a62',
    color: 'white',
}));

const AboutSection = styled(Box)(({ theme }) => ({
    position: 'relative',
    padding: theme.spacing(8, 0),
    backgroundColor: '#f8f9fa',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '100%',
        background: 'linear-gradient(135deg, rgba(0, 106, 98, 0.05) 0%, rgba(0, 106, 98, 0.1) 100%)',
        zIndex: 0,
    },
}));

const Profile = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box>
            {/* About Section */}
            <AboutSection>
                <Container maxWidth="lg">
                    <Grid container spacing={6}>
                        <Grid item xs={12} md={6}>
                            <Box sx={{ position: 'relative', zIndex: 1 }}>
                                <Typography
                                    variant="h3"
                                    sx={{

                                        fontWeight: 'bold',
                                        mb: 4,
                                        background: 'linear-gradient(to right, #1976d2, #512da8)',
                                        backgroundClip: 'text',
                                        textFillColor: 'transparent',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                        mb: 3,
                                        textAlign: isMobile ? 'center' : 'left'
                                    }}
                                >
                                    About NYCS
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        fontSize: '1.1rem',
                                        lineHeight: 1.8,
                                        color: '#333',
                                        mb: 3
                                    }}
                                >
                                    National Yuva Co-operative society Ltd. (NYCS Ltd.) is a multistate, multipurpose cooperative institution working towards making youth economically independent by engaging them in various employment and self-employment related activities.
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        fontSize: '1.1rem',
                                        lineHeight: 1.8,
                                        color: '#333',
                                        mb: 3
                                    }}
                                >
                                    Since its inception in 1999, NYCS has focused on developing and nurturing entrepreneurs across India. We operate in 603 districts, providing entrepreneurship training, book keeping education, marketing skills, soft skills, and managerial expertise.
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box
                                sx={{
                                    height: '100%',
                                    minHeight: 400,
                                    borderRadius: 4,
                                    overflow: 'hidden',
                                    position: 'relative'
                                }}
                            >
                                <Box
                                    component="img"
                                    src="/Events/img-5.jpg"
                                    alt="NYCS Activities"
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        borderRadius: 4,
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>




                    <Grid container spacing={6} sx={{ mt: "20px" }}>

                        <Grid item xs={12} md={6}>
                            <Box
                                sx={{
                                    height: '100%',
                                    minHeight: 400,
                                    borderRadius: 4,
                                    overflow: 'hidden',
                                    position: 'relative'
                                }}
                            >
                                <Box
                                    component="img"
                                    src="/Events/img-10.jpg"
                                    alt="NYCS Activities"
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        borderRadius: 4,
                                    }}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box sx={{ position: 'relative', zIndex: 1 }}>
                                <Typography
                                    variant="h3"
                                    sx={{

                                        fontWeight: 'bold',
                                        mb: 4,
                                        background: 'linear-gradient(to right, #1976d2, #512da8)',
                                        backgroundClip: 'text',
                                        textFillColor: 'transparent',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                        mb: 3,
                                        textAlign: isMobile ? 'center' : 'left'
                                    }}
                                >
                                    Our Mission
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        fontSize: '1.1rem',
                                        lineHeight: 1.8,
                                        color: '#333',
                                        mb: 3
                                    }}
                                >
                                    Open every possible avenue and touch
                                    any field that offers a gateway to the entrepreneurial mind-set of the youth
                                    and to sharpen his / her employable
                                    skills.
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        fontSize: '1.1rem',
                                        lineHeight: 1.8,
                                        color: '#333',
                                        mb: 3
                                    }}
                                >
                                    Make the youth economically productive
                                    and improve their quality of life
                                    ensuring youth empowerment for a self
                                    reliant and developed India.

                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        fontSize: '1.1rem',
                                        lineHeight: 1.8,
                                        color: '#333',
                                        mb: 3
                                    }}
                                >
                                    Initiate, aid, or assist as a catalyst into
                                    any effort that aims at youth
                                    empowerment and craft their potential
                                    into creating entrepreneurs and leaders
                                    of the future

                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </AboutSection>
        </Box>
    );
};

export default Profile;